import { charities } from "../lib/charities";

export const getCharityData = (charityName) => {
  const charityData = charities.filter(
    (charity) => charity.title === charityName
  );

  if (charityData && charityData.length) return charityData[0];
};
